// ** Auth Endpoints
export const isDev = process.env.NODE_ENV === "development"
const hostname = window.location.hostname

function isIpAddressOrDomain(isMap, isHttps) {
  let url
  // Regular expression to match an IP address
  const ipPattern = /^(\d{1,3}\.){3}\d{1,3}$/
  // Regular expression to match a domain name
  const domainPattern = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

  // Check if the location.host matches either the IP address pattern or the domain name pattern
  if (ipPattern.test(window.location.host) && (window.location.port >= 3000 && window.location.port <= 3100) === false) {
    if (isMap) {
      if (isHttps) url = `https://${window.location.host}`
      else url = `http://${window.location.host}`
    } else {
      url = `http://${window.location.host}:8081`
    }
  } else if (domainPattern.test(window.location.host)) {
    if (isMap) url = `https://${window.location.host}`
    else url = `https://api.${window.location.host}`
  }
  return url
}

// const host = isDev ? `http://10.2.1.3:8082` : isIpAddressOrDomain() // 10.2.1.3
// const host = isDev ? `http://192.168.5.2:8081` : isIpAddressOrDomain() // Ahrorbek's Server
// const host = isDev ? `http://192.168.5.34:8081` : isIpAddressOrDomain() // Ilhom's Server
// const host = isDev ? `http://192.168.5.132:8082` : isIpAddressOrDomain() // Kay's Server
// const host = isDev ? `http://192.168.5.135:8082` : isIpAddressOrDomain() // Sarvar's Server
// const host = isDev ? `http://192.168.5.128:8082` : isIpAddressOrDomain() // Asliddin's Server
// const host = isDev ? `http://10.2.1.105:8082` : isIpAddressOrDomain() // 10.2.1.105
// const host = isDev ? `http://10.2.1.108:8082` : isIpAddressOrDomain() // 10.2.1.108
const host = isDev ? "http://10.251.6.250:8081" : isIpAddressOrDomain() // 10.251.6.250

const ligth_map_tile = isDev ? process.env.REACT_APP_DEVELOPMENT_MAP_URL_LIGHT : `${isIpAddressOrDomain("map")}/osm_tiles/{z}/{x}/{y}.png`

const satellite_map_tile = isDev ? process.env.REACT_APP_DEVELOPMENT_MAP_URL_SATELLITE : `${isIpAddressOrDomain("map", "https")}/sat_tiles/{z}/{x}/{y}.jpg`

const main = isDev ? process.env.REACT_APP_DEVELOPMENT_MAP_URL_MAIN : `${isIpAddressOrDomain("map")}/main/{z}/{x}/{y}.png`

const test_one = isDev ? process.env.REACT_APP_DEVELOPMENT_MAP_URL_TEST_ONE : `${isIpAddressOrDomain("map")}/test_one/{z}/{x}/{y}.png`

const test_two = isDev ? process.env.REACT_APP_DEVELOPMENT_MAP_URL_TEST_TWO : `${isIpAddressOrDomain("map")}/test_two/{z}/{x}/{y}.png`

const test_three = isDev ? process.env.REACT_APP_DEVELOPMENT_MAP_URL_TEST_THREE : `${isIpAddressOrDomain("map")}/test_three/{z}/{x}/{y}.png`

const test_four = isDev ? process.env.REACT_APP_DEVELOPMENT_MAP_URL_TEST_FOUR : `${isIpAddressOrDomain("map")}/test_four/{z}/{x}/{y}.png`

export default {
  url: host,
  loginEndpoint: `${host}/auth`,
  registerEndpoint: "/jwt/register",
  refreshEndpoint: `${host}/auth`,
  logoutEndpoint: "/jwt/logout",
  xHost: new URL(host).origin,
  // ** This will be prefixed in authorization header with token
  // ? e.g. Authorization: Bearer <token>
  tokenType: "Bearer",

  // ** Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: "access_token",
  storageRefreshTokenKeyName: "access_token",
  timer: 30000,
  timerDRB: 5000,
  gpsTimer: 10000,
  ligth_map_tile: `${isDev ? process.env.REACT_APP_DEVELOPMENT_MAP_URL_LIGHT : ligth_map_tile}`,
  satellite_map_tile: `${isDev ? process.env.REACT_APP_DEVELOPMENT_MAP_URL_SATELLITE : satellite_map_tile}`,
  main: `${isDev ? process.env.REACT_APP_DEVELOPMENT_MAP_URL_MAIN : main}`,
  test_one: `${isDev ? process.env.REACT_APP_DEVELOPMENT_MAP_URL_TEST_ONE : test_one}`,
  test_two: `${isDev ? process.env.REACT_APP_DEVELOPMENT_MAP_URL_TEST_TWO : test_two}`,
  test_three: `${isDev ? process.env.REACT_APP_DEVELOPMENT_MAP_URL_TEST_THREE : test_three}`,
  test_four: `${isDev ? process.env.REACT_APP_DEVELOPMENT_MAP_URL_TEST_FOUR : test_four}`
}
